import { Box } from "@mui/material";
import React from "react";
import CreateInterviewForm from "../../../../Components/RecruitmentModule/CreateInterview/CreateInterviewForm";

const CreateUpdateInterview = () => {
   
  return (
     <Box sx={{p : 4}}>
     <CreateInterviewForm />
     </Box>
  );
};

export default CreateUpdateInterview;
